var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKnife = function SvgIconKnife(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m18.75 13.5.8.6a1 1 0 0 0-.093-1.307l-1.584-1.585 4.044-4.317a2.87 2.87 0 0 0-4.071-4.045l-.008.008-4.765 4.88a1 1 0 0 0-.104.107L1.535 19.55a1 1 0 0 0 .49 1.673c5.24 1.21 9.65-.617 12.692-2.677a23 23 0 0 0 3.543-2.98 20 20 0 0 0 1.195-1.345l.068-.086.018-.025.006-.007.002-.002.001-.002zm.514-9.243-4.122 4.22 1.316 1.316 4.01-4.28.022-.023a.87.87 0 0 0-1.226-1.233m-3.487 7.684-.007-.007-2.025-2.025-9.43 9.656c3.716.314 6.894-1.058 9.28-2.674a21 21 0 0 0 3.801-3.33z",
    clipRule: "evenodd"
  })));
};
export default SvgIconKnife;